<template>
  <div class="manuAssign">
    <template>
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        @search="searchList"
        :batchOperBtn="batchOperBtn"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        :tableOption="tableOption"
        :isDisabledMultiple="isDisabledMultiple"
        @handleSelectionChange="bachOper"
        @changeNum="changeNum"
        @changePage="changePage"
      >
      </ots-table-group-new>

      <ots-custom-dialog :dialog.sync="setAllReviewDialog" title="批量分配">
        <template v-slot:content>
          <p class="BatchAllocation">
            为<span class="dis-red"
              >&nbsp;{{ batchDialogForm.length }}&nbsp;</span
            >位考生分配<span class="dis-red"
              >&nbsp;{{ batchCourseName }}&nbsp;</span
            >的评阅教师。
          </p>
          <span class="BatchAllocation-span">评阅教师</span>
          <el-select v-model="ReviewTeacherId" placeholder="请选择">
            <el-option
              v-for="item in teacherList"
              :key="item.teacherId"
              :label="item.teacherName"
              :value="item.teacherId"
            ></el-option>
          </el-select>
        </template>
        <template v-slot:footer>
          <el-button round @click="setAllReviewDialog = false">取消</el-button>
          <el-button round type="primary" @click="isSetBatchAllocation">确认分配</el-button>
        </template>
      </ots-custom-dialog>
    </template>
  </div>
</template>

<script>
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import {
  getSinglePlan,
  getSelectPlanFn,
} from "@/http/modules/examSet/examBatch";

import {
  getSession,
  getReTeacher,
  geTeacherList,
  bulkLocation,
  delLocationSet,
  exportLocation,
} from "@/http/modules/markPaper";

export default {
  data() {
    return {
      // 标题按钮
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportReview,
        },
      ],
      // 查询表单
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "教学点",
          type: "select",
          requestKey: "stationIds",
          isSearch: true,
          multiple: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "课程",
          type: "select",
          requestKey: "courseId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "场次",
          type: "select",
          multiple: true,
          label: "sessionName",
          value: "sessionId",
          requestKey: "sessionIds",
          data: [],
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "考试情况",
          type: "select",
          requestKey: "examState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已考" },
            { id: 0, name: "未考" },
          ],
        },
        {
          title: "分配状态",
          type: "select",
          label: "name",
          value: "id",
          requestKey: "allocationState",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已分配" },
            { id: 0, name: "未分配" },
          ],
        },
        {
          title: "学生",
          type: "input",
          requestKey: "user",
          placeholder: "请输入姓名或证件号",
        },
        {
          title: "评阅教师",
          type: "select",
          label: "teacherName",
          value: "teacherId",
          requestKey: "teacherId",
          data: [],
        },
        {
          title: "评阅状态",
          type: "select",
          label: "name",
          value: "id",
          requestKey: "status",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已评阅" },
            { id: 0, name: "未评阅" },
          ],
        },
      ],
      /* ** 请求参数 ** */
      requestForm: {
        planId: "",
        stationIds: [""],
        schoolId: "",
        courseId: "",
        sessionIds: [""],
        examState: "",
        allocationState: "",
        status: "",
        user: "",
        teacherId: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "姓名",
          prop: "studentName",
        },
        {
          title: "证件号",
          prop: "userNo",
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "院校",
          prop: "schoolName",
        },
        {
          title: "场次",
          prop: "sessionName",
        },
        {
          title: "考试情况",
          prop: "examState",
        },
        {
          title: "评阅教师",
          prop: "teacherName",
        },
        {
          title: "评阅状态",
          prop: "reviewState",
        },
      ],
      batchOperBtn: [],
      tableData: [],
      tableOption: {
        multiple: true,
        selectTable: this.isCanSelectFn,
      },
      pagination: {
        total: 0,
      },
      // 多选列表
      checkList: [],
      // 批量分配列表
      batchDialogForm: [],
      // 批量分配弹窗
      setAllReviewDialog: false,
      // 批量分配教师ID
      ReviewTeacherId: "",
      // 批量分配课程名
      batchCourseName: "",
      // 评阅教师列表
      teacherList: [],
    };
  },
  watch: {
    "requestForm.planId"(val) {
      this.getThisPlanCourse(val);
    },
    "requestForm.courseId"(val) {
      this.getThisPlanTeacher(val);
    },
    teacherList(val) {
      if (val.length == 1) {
        this.ReviewTeacherId = val[0].teacherId;
      } else {
        this.ReviewTeacherId = "";
      }
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    /***************************
     * @this 已评阅列表禁用多选框
     ***************************/
    isDisabledMultiple(row) {
      let { reviewState } = row;
      if (reviewState !== "已评阅") {
        return true;
      } else {
        return false;
      }
    },

    /***********************************
     * @initData 初始化表单数据
     ***********************************/
    initData() {
      /* ** 考试批次 ** */
      getSelectPlanFn({ needAudit: 6 }).then(({ data }) => {
        this.selectList[0].data = data;
        this.requestForm.planId = data[0].id;
      });
      /* ** 教学点 ** */
      this.mixin_getSelectStation().then((data) => {
        this.selectList[1].data = [{ id: "", name: "全部" }, ...data];
      });
      /* ** 院校 ** */
      this.mixin_getSelectSchool().then((res) => {
        this.selectList[4].data = [{ id: "", name: "全部" }, ...res];
      });
    },

    /***********************************
     * @this 根据批次查询课程,场次
     ***********************************/
    getThisPlanCourse(planId) {
      let btnList = [
        {
          title: "批量分配",
          icon: "iconfont icon-fuzhi",
          click: this.batchReview,
        },
        {
          title: "删除分配",
          icon: "iconfont icon-shanchu",
          click: this.deleteReview,
        },
      ];
      getPlanCourseFn({ planId: planId })
        .then((res) => {
          let courseData = res.data.map((e) => {
            return { id: e.courseId, name: e.courseName };
          });
          this.selectList[2].data = courseData;
          this.requestForm.courseId = courseData[0].id;
          return getSession({ planId: planId });
        })
        .then((res) => {
          if (res.code == 1) {
            let sessionList = res.data[0].sessionOVList;
            this.selectList[3].data = [
              { sessionId: "", sessionName: "全部" },
              ...sessionList,
            ];
            this.requestForm.sessionIds = [""];
            this.search();
          }
          return getSinglePlan({ planId: planId });
        })
        .catch((err) => {
          this.selectList[3].data = [{ sessionId: "", sessionName: "全部" }];
          this.requestForm.sessionIds = [""];
          this.search();
          return getSinglePlan({ planId: planId });
        })
        .then((res) => {
          if (res.data.scorePublish != 1) {
            this.batchOperBtn = btnList;
            this.tableOption.multiple = true;
          } else {
            this.batchOperBtn = [];
            this.tableOption.multiple = false;
          }
        });
    },

    /***********************************
     * @this 根据课程查询评阅教师
     ***********************************/
    getThisPlanTeacher(courseId) {
      let params = {
        courseId: courseId,
      };
      getReTeacher(params).then((res) => {
        this.selectList[8].data = [
          { teacherId: "", teacherName: "全部" },
          ...res.data,
        ];
        this.teacherList = [...res.data];
        this.requestForm.teacherId = "";
      });
    },

    /***********************************
     * @this 批量分配
     ***********************************/
    batchReview() {
      this.selectList[2].data.map((e) => {
        if (e.id == this.requestForm.courseId) {
          this.batchCourseName = e.name;
        }
      });

      if (this.checkList.length > 0) {
        this.batchDialogForm = this.checkList;
      } else {
        this.batchDialogForm = [];
        this.tableData.map((e) => {
          if (e.reviewState !== "已评阅") {
            this.batchDialogForm.push(e);
          }
        });
      }

      if (this.selectList[8].data.length == 2) {
        this.ReviewTeacherId = this.selectList[8].data[1].teacherId;
      }
      this.setAllReviewDialog = true;
    },

    /***********************************
     * @this 确认分配
     ***********************************/
    isSetBatchAllocation() {
      let params = {
        studentCourseId: this.batchDialogForm.map((e) => { return e.studentCourseId }).join(),
        teacherId: this.ReviewTeacherId,
      };
      bulkLocation(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功！");
          this.setAllReviewDialog = false;
          this.search();
        }
      });
    },

    // /sign/ReviewTeacher/bulkAllocation
    // 
    /***********************************
     * @this 批量删除
     ***********************************/
    deleteReview() {
      if (this.checkList.length > 0) {
        this.$confirm("确认删除您选择的未评阅的分配信息？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let params = {
              studentCourseIds: this.checkList
                .map((e) => {
                  return e.studentCourseId;
                })
                .join(),
            };
            delLocationSet(params).then((res) => {
              if (res.code == 1) {
                this.$message.success("已删除成功！");
                this.search();
              }
            });
          })
          .catch(() => {});
      } else {
        this.$message.warning("请勾选要删除的分配信息！");
      }
    },

    /***********************************
     * @this 多选绑定
     ***********************************/
    bachOper(val) {
      this.checkList = val;
    },

    /***********************************
     * @this 导出
     ***********************************/
    exportReview() {
      let params = { ...this.requestForm };
      params.stationIds = params.stationIds.join();
      params.sessionIds = params.sessionIds.join();
      exportLocation(params).then((res) => {
        if (res.code == 1) {
          window.location.href = res.data;
        }
      });
    },

    /***********************************
     * @this 查询按钮
     ***********************************/
    searchList() {
      this.requestForm.size = 10;
      this.requestForm.page = 1;
      this.search();
    },

    /***********************************
     * @this 查询
     ***********************************/
    search() {
      let params = { ...this.requestForm };
      params.stationIds = params.stationIds.join();
      params.sessionIds = params.sessionIds.join();
      geTeacherList(params).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        }
      });
    },

    /***********************************
     * @this 分页-每页数量
     ***********************************/
    changeNum(num) {
      this.requestForm.size = num;
      this.search();
    },

    /***********************************
     * @this 分页-页码
     ***********************************/
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
.BatchAllocation {
  margin-bottom: 16px;
}
.BatchAllocation-span {
  margin-right: 8px;
}
.BatchAllocation-button {
  margin-top: 16px;
}
.dis-red {
  color: #fe5958;
  font-weight: 500;
}
</style>
